type DataRow = Record<string, any>; // eslint-disable-line @typescript-eslint/no-explicit-any

export const exportCsv = (
  data: DataRow[],
  filename: string = "export.csv",
): void => {
  // Convert data to CSV format
  const headers = Object.keys(data[0] || {});
  const csvRows = [
    // Add header row
    headers.join(","),
    // Add data rows
    ...data.map((row) =>
      headers
        .map((header) => {
          const value = row[header];
          // Handle special cases (null, undefined, objects)
          if (value == null) return "";
          if (typeof value === "object") return JSON.stringify(value);
          // Escape quotes and wrap in quotes if contains comma
          const stringValue = String(value);
          return stringValue.includes(",")
            ? `"${stringValue.replace(/"/g, '""')}"`
            : stringValue;
        })
        .join(","),
    ),
  ];

  const csvContent = csvRows.join("\n");

  // Create and trigger download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");

  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
